import React, { useEffect, useState } from 'react';

import { Dates } from 'context/DateProvider/DateProvider';
import { convertNowToISO } from 'context/DateProvider/utils/convertNowToISO';
import EventsChart from 'features/Events/components/EventsChart';
import { EventData } from 'features/Events/types/eventData';
import useFetchWithToken from 'hooks/useFetchWithToken';
import { WHITE } from 'utils/colours';
import { FRAMES_API_URL } from 'utils/environmentVariables';

type EventsChartContainerProps = {
  frameId: string;
  dates: Dates;
};

const EventsChartContainer = ({ frameId, dates }: EventsChartContainerProps) => {
  const [events, setEvents] = useState<EventData[]>([]);
  const { fetchDataWithToken } = useFetchWithToken();

  useEffect(() => {
    if (frameId) {
      const url = `${FRAMES_API_URL}/${frameId}/events?from=${dates.from}&to=${dates.to}`;
      fetchDataWithToken<EventData[]>(url, (data) => setEvents(data));
    }
  }, [frameId, dates]);

  return (
    <EventsChart
      chartId={`events-chart-${frameId}`}
      chartData={events}
      minDateTimeRange={convertNowToISO(dates.from)}
      maxDateTimeRange={convertNowToISO(dates.to)}
      lineColor={WHITE}
    />
  );
};

export default EventsChartContainer;
